import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919270425109";

export default function WhatsAppWidget() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%20need%20home%20care%20services`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform wa-pulse"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
